// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1T-k_","alertIcon":"ConfirmModal_alertIcon__gPl3F"};